import { supabase } from '@/supabase/client';
import type { User } from '@supabase/supabase-js';

/**
 * Check if the current user has admin privileges
 * @param user - The user to check admin status for
 * @returns Promise<boolean> - true if user is admin, false otherwise
 */
export const checkAdminStatus = async (user: User | null): Promise<boolean> => {
  try {
    if (!user) {
      return false;
    }

    // Call the is_admin RPC function to check admin status
    const { data: isAdmin, error } = await supabase.rpc('is_admin', {
      user_uuid: user.id,
    });

    if (error) {
      console.error('RPC error:', error);
      return false;
    }

    return Boolean(isAdmin);
  } catch {
    return false;
  }
};
